import { UserAPI } from "API/userApi";
import { IPerson, IResponseShot } from "interfaces/intarfaces";
import { API_USERS } from "./constants";
import { setTimeoutAsync } from "./helpers";
import { resizeImages } from "./resizeImages";

const numberAttempts = 3;
const delay = 2 * 1000;

export const tryLoadAvatar = async (
  user_ID: string,
  colAttempts: number = 3
): Promise<[string, boolean]> => {
  let response;
  for (let _ = 0; _ < colAttempts; _++) {
    response = await setTimeoutAsync(async () => {
      const res = await UserAPI.get(API_USERS + user_ID);
      const obj: IPerson = res;

      return [
        (obj && obj.hasOwnProperty("thumbnail_url")
          ? obj.thumbnail_url
          : "") as string,
        obj.is_profile_complete,
      ];
    }, delay);

    if (!!(response as [string, boolean])[0].length)
      return response as [string, boolean];
  }
  return ["", false];
};

export const uploadAvatar = async (
  avatar: File | undefined,
  userID: string | undefined
): Promise<[string, boolean | undefined]> => {
  if (!avatar || !!!userID?.length) return ["", undefined];

  const newImg = await resizeImages([avatar]);
  if (!!!newImg.length) return ["", false];

  const responseUpload: IResponseShot = await UserAPI.upload(
    API_USERS + `${userID}/upload-avatar`,
    newImg[0]
  );

  if (responseUpload.hasOwnProperty("success") && responseUpload.success) {
    return await tryLoadAvatar(userID, numberAttempts);
  }
  return ["invalid_type", false];
};
